import { render } from "./vdmShed.vue?vue&type=template&id=2dfa1248&scoped=true"
import script from "./vdmShed.vue?vue&type=script&lang=js"
export * from "./vdmShed.vue?vue&type=script&lang=js"

import "./vdmShed.vue?vue&type=style&index=0&id=2dfa1248&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfa1248"]])

export default __exports__